/**流程和物流记录路由 */
export default [
    {
        name:'process',
        path:'process',
        meta: { title: '流程和物流记录' },
        component: ()=>import('@/pages/process/index.vue')
    }
]